<template>
    <div ref="phishingTool" v-if="viewData.isInitializationDone">
        <div class="row" v-if="viewData.currentPage === viewData.pages.PHISHING_FORM">
            <div class="column">
                <h5>Bitte füllen Sie das folgende Formular vollständig aus</h5>
                <PhishingForm ref="phishingForm" @send="createCase"/>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.SUCCESS_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="ratisColoredText">
                        Ihr Schreiben wurde an die Bank versendet
                    </h4>
                    <p>
                        Sie erhalten eine Kopie der versandten E-Mail an die von Ihnen angegebene E-Mail-Adresse.
                    </p>
                    <p>
                        Nun hat die Bank einen Tag Zeit die geforderte Erstattung zu leisten. Sie erhalten daher in zwei
                        Tagen eine Erinnerungs-E-Mail von uns. Wenn die Bank bis dahin nicht reagiert hat, erhalten Sie
                        darin die Informationen zu den weiteren Schritten.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Neue Eingabe starten</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.ERROR_PAGE">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Es ist ein Fehler aufgetreten
                    </h4>
                    <p>
                        Wir bitten Sie um Entschuldigung.
                        Leider ist beim Versand des Formulars ein Fehler aufgetreten.
                        Bitte versuchen Sie es erneut.
                        Sollten Sie auch nach einem neuerlichen Versuch immer noch Probleme haben, wenden Sie sich bitte an
                        <a href="mailto:info@ratis.de">info@ratis.de</a>.
                    </p>
                </div>
            </div>
            <div class="column">
                <button class="button success expand" @click="resetForm">Erneut versuchen</button>
            </div>
        </div>
        <div class="row" v-else-if="viewData.currentPage === viewData.pages.APP_DOWN">
            <div class="column">
                <div class="panel" align="center">
                    <h4 class="redColoredText">
                        Anwendung nicht verfügbar
                    </h4>
                    <p>
                        Die Anwendung steht aktuell leider nicht zur Verfügung. Bitte versuchen Sie es später erneut.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PhishingForm from '../components/PhishingForm';
import Phishing from '../api/phishing';
import Config from '../constants/Config';
import Maintenance from '../api/maintenance';

export default {
    name: 'FormView',
    components: {PhishingForm},
    data: () => ({
        viewData: {
            currentPage: 0,
            pages: {
                PHISHING_FORM:  0,
                SUCCESS_PAGE:   1,
                ERROR_PAGE:     2,
                APP_DOWN:       3
            },
            isInitializationDone: false
        }
    }),
    methods: {
        validateForm()
        {
            this.$refs.phishingForm.validateForm();
        },
        async createCase(caseData)
        {
            try
            {
                let requestData = {
                    caseData: caseData
                };

                await Phishing.createNewCase(requestData);
                this.viewData.currentPage = this.viewData.pages.SUCCESS_PAGE;

                this.createTrackingIframe();
            }
            catch (error)
            {
                this.viewData.currentPage = this.viewData.pages.ERROR_PAGE;
            }
            finally
            {
                this.$refs.phishingTool.scrollIntoView(true);
            }
        },
        async resetForm()
        {
            await this.checkHealth();

            if (this.viewData.currentPage !== this.viewData.pages.APP_DOWN)
            {
                this.viewData.currentPage = this.viewData.pages.PHISHING_FORM;
            }
            this.$refs.phishingTool.scrollIntoView(true);
        },
        createTrackingIframe()
        {
            let iframe = document.createElement('iframe');
            iframe.setAttribute('id', 'trackingIframe');
            iframe.setAttribute('src', Config.TRACKING_URL);
            iframe.style.display = "none";
            document.body.appendChild(iframe);
            let me = this;
            iframe.onload = () => me.removeTrackingIframe();
        },
        removeTrackingIframe()
        {
            let iframe = document.getElementById('trackingIframe');
            document.body.removeChild(iframe);
        },
        async checkHealth()
        {
            try
            {
                let response = await Maintenance.checkHealth();

                if (response.is_down)
                    this.viewData.currentPage = this.viewData.pages.APP_DOWN;
            }
            catch (error)
            {
                this.viewData.currentPage = this.viewData.pages.APP_DOWN;
            }
        }
    },
    async mounted()
    {
        await this.checkHealth();
        this.viewData.isInitializationDone = true;
    }
};
</script>

<style scoped>
    .ratisColoredText{
        color:#e10065;
    }
    .redColoredText{
        color: red;
    }
</style>